var render = function render(){var _vm=this,_c=_vm._self._c;return _c('newsletter',{attrs:{"data":_vm.newsletterData}})
}
var staticRenderFns = []

export { render, staticRenderFns }